import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {DoctorService} from '../../services/doctor/doctor.service';
import {iResponse} from '../../models/response/response.model';
import {DoctorCreateModel, DoctorModel} from '../../models/doctor/doctor.model';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatInput} from '@angular/material/input';
import {InfoMessageService} from '../../services/infomessage/infomessage.service';

@Component({
    selector: 'app-doctor-create',
    imports: [
        ReactiveFormsModule,
        MatInput
    ],
    templateUrl: './doctor-create.component.html',
    styleUrl: './doctor-create.component.sass'
})
export class DoctorCreateComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>()
    @Input() practiceId: string = ''
    @Output() created: EventEmitter<DoctorModel> = new EventEmitter<DoctorModel>()
    @Output() triggerDoctorCreate: EventEmitter<string> = new EventEmitter<string>()

    doctorForm: FormGroup = new FormGroup({
        email: new FormControl('', Validators.required),
        firstName: new FormControl('', Validators.required),
        lastName: new FormControl('', Validators.required),
        mobilePhone: new FormControl(''),
        telePhone: new FormControl(''),
        skype: new FormControl(''),
        title: new FormControl(''),
        practiceId: new FormControl('', Validators.required),
    })

    constructor(
        private doctorService: DoctorService,
        private infoMessageService: InfoMessageService
    ) {
    }

    ngOnInit(): void {
        if (this.practiceId) {
            this.doctorForm.get('practiceId')?.patchValue(this.practiceId);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next()
        this.destroy$.complete()
    }

    cancel(): void {
        this.triggerDoctorCreate.emit();
    }

    submit(): void {
        if (this.doctorForm.invalid) {
            this.doctorForm.markAllAsTouched();
            return;
        }

        const newDoctor: DoctorCreateModel = this.doctorForm.value
        this.createDoctor(newDoctor)
    }

    private createDoctor(doctor: DoctorCreateModel): void {
        this.doctorService.createDoctor(doctor)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponse<DoctorModel>) => {
                    this.created.emit(response.data);
                    this.doctorForm.reset();
                    this.infoMessageService.createMessage('Arzt erfolgreich erstellt', 'success');
                },
                error: (error) => {
                    if (error.error.error.includes('same email')) {
                        this.infoMessageService.createMessage('Ein Arzt mit dieser E-Mail Adresse existiert bereits', 'error');
                    } else {
                        this.infoMessageService.createMessage('Arzt konnte nicht erstellt werden', 'error');
                    }
                }
            })
    }

}
